import _ from "lodash"

export default ( state: any = {}, action: any ) => {
  const expenseTypes = state.expenseTypes || []

  switch ( action.type ) {
  case "BULK_ADD_EXPENSE_TYPE":
    return {
      ...state,
      expenseTypes: [
        ...expenseTypes,
        ...action.expenseTypes,
      ],
    }
  case "UPDATE_EXPENSE_TYPE":
    return {
      ...state,
      expenseTypes: [
        ..._.filter( expenseTypes, et => et.id !== action.expenseType.id ),
        {
          ..._.find( expenseTypes, { id: action.expenseType.id } ),
          ...action.expenseType,
        },
      ],
    }
  case "ADD_EXPENSE_TYPE":
    return {
      ...state,
      expenseTypes: [
        ..._.filter( expenseTypes, et => et.id !== action.expenseType.id ),
        action.expenseType,
      ],
    }
  case "REMOVE_EXPENSE_TYPE":
    return {
      ...state,
      expenseTypes: _.filter( expenseTypes, et => et.id !== action.expenseType.id ),
    }
  case "REMOVE_AUTOMATIC_EXPENSE_RULE":
    return {
      ...state,
      expenseTypes: expenseTypes.map( et => ( {
        ...et,
        automaticExpenseRules: et
          .automaticExpenseRules
          .filter( aer => aer.id !== action.id ),
      } ) ),
    }
  case "ADD_AUTOMATIC_EXPENSE_RULE":
    return {
      ...state,
      expenseTypes: expenseTypes.map( et => {
        if ( et.id === action.idExpenseType ) {
          return {
            ...et,
            automaticExpenseRules: [
              ...et.automaticExpenseRules,
              action.automaticExpenseRule,
            ],
          }
        } else {
          return et
        }
      } ),
    }
  case "REMOVE_EXPENSE_TYPE_STATE_TRANSITION":
    return {
      ...state,
      expenseTypes: expenseTypes.map( et => {
        if ( et.id === action.idExpenseType ) {
          return {
            ...et,
            stateTransitions: et
              .stateTransitions
              .filter( transition => !_.isEqual(
                _.pick( transition, [ "fromState", "toState" ] ),
                _.pick( action.stateTransition, [ "fromState", "toState" ] )
              ) ),
          }
        } else {
          return et
        }
      } ),
    }
  case "ADD_EXPENSE_TYPE_STATE_TRANSITION":
    return {
      ...state,
      expenseTypes: expenseTypes.map( et => {
        if ( et.id === action.idExpenseType ) {
          return {
            ...et,
            stateTransitions: [
              ...et.stateTransitions,
              action.stateTransition,
            ],
          }
        } else {
          return et
        }
      } ),
    }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/expenses.jsx